import React from "react";
import { GrPrevious, GrNext } from "react-icons/gr";
import Slider from "react-slick";
import { URL_IMAGE } from "../../services/api/config";
const NewSlider = ({ dataSource }) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 200,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        onClick={onClick}
        style={{
          top: "50%",
          right: "0",
          width: "32px",
          height: "32px",
          position: "absolute",
          transform: "translate(-50%,-50%)",
          border: "1px solid rgb(32,56,78)",
          borderRadius: "50%",
          background: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <GrNext size={16} color="rgb(32,56,78)" />
      </div>
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        onClick={onClick}
        style={{
          top: "50%",
          left: "0",
          width: "32px",
          height: "32px",
          position: "absolute",
          transform: "translate(-50%,-50%)",
          border: "1px solid rgb(32,56,78)",
          borderRadius: "50%",
          background: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <GrPrevious size={16} color="rgb(32,56,78)" />
      </div>
    );
  }

  return (
    <Slider {...settings} style={{ width: "70%" }}>
      {dataSource?.images?.map((x, indexx) => (
        <div className="homepage__block1__slide__image__new" key={indexx}>
          <img src={`${URL_IMAGE}` + x} href="block2" />
        </div>
      ))}
    </Slider>
  );
};

export default NewSlider;
